export const translations = {
  en: {
    announcementBanner: {
      dismiss: "Dismiss",
    },
    footer: {
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      terms: "Terms of Service",
      contact: "Contact Us",
    },
    contactUsForm: {
      heading: "Contact us",
      messageLabel: "What is on your mind?",
      submit: "Send",
      messageError: "You need to provide a message",
      receupt: "Thank you for your message. We will get back to you as soon as possible.",
    },
    coupons: {
      title: "Christmas Offer",
      body: "It is christmas time, and we celebrate by offering a 25% discount for the first year. Activate your subscription by December 14th and use the following code in the checkout form:",
      button: "Start your subscription",
    },
    screenshotView: {
      labelCanvas: "Canvas color",
      labelFg: "Foreground color",
      labelBg: "Background color",
      downloadImage: "Download",
      presetsTitle: "Color pairs",
      preset_cream: "Petrol on cream",
      preset_petrol: "Cream on petrol",
      preset_white: "Petrol on white",
      preset_amber: "Petrol on amber",
    },
    help: {
      invitationText:
        "This is included in the email and in the responder form. You should make it personal, and explain why you want the responder to answer the survey.",
      surveyType:
        "The survey type defines which questions to ask the responders. Choose the type that best fits your working relationship with the responders.",
      onBehalfOf:
        "Because you have the supporter- or owner role, you can create surveys on behalf of others. They will get access to it as if it was their own, but you can collaborate on inviting responders.",
      endDate: "This date determines how long it will be possible to answer. Responders who have not answered by this date will get an error message.",
      defaultLang: "This sets the standard language for the email and responder form. It can be overridden for each individual invite.",
      accessibleBy:
        "Here you can choose who should be able to read the results from the survey. You can choose between yourself, supporters, selected groups or everyone in the organization. Those you give access will be able to help you with the surveys, set an improvement goal together with you, and follow up on specific feedback.",
      goalEndDate:
        "This date determines when the goal should be reached. It is important that you set a realistic date, so that it is possible to achieve changes, while it is tight enough to make the results comparable. We recommend at least six months.",
      goal: "Describe what you want to improve. This can be a specific skill, a process or a relationship. The clearer the goal is, the better!",
      improvementSelector:
        "Here you can choose which categories you want to focus on in the improvement goal. Choose the one or ones that best fit the goal you have set.",
      situation:
        "How is the situation now? In light of the areas you want to improve, how are you doing, and how is this reflected in the results from the survey?",
      plan: "Here you can enter a description of your implementation plan. What will you do to reach the goal? Which activities will you carry out, and what do you need to succeed?",
      goalAccessibleBy:
        "Here you can choose who should be able to see your goal, but you can only choose among those who can see the survey the goal is started from. Those who have access to the goal do not automatically have access to new surveys.",
      candidate: "Your name. This will be displayed in the invitations to respondents, in the questionnaire, and on the Journey cards.",
      title: "Your title. This will be displayed in the invitations to respondents, in the questionnaire, and on the Journey cards.",
      groupName: "Group name. You can later add members to this group.",
      departmentName: "Department name. You can later add members to this department.",
      responderMessage:
        "If you have other feedback than what appears in the evaluation, or if there are any answers you would like to elaborate on, you can enter it here.",
      recommendationName: "To give your recommendation credibility, we ask that you enter your name. This will be displayed along with the recommendation.",
      recommendationTitle: "To give your recommendation credibility, we ask that you enter your title. This will be displayed along with the recommendation.",
      goalIsSuccessHelp:
        "You must decide for yourself whether the goal has been reached or not. If you are in doubt, consider whether you have made progress and are closer to the goal than when you started. Perhaps it is successful even if the results are not exactly as you had hoped? With continuous improvement, you will soon get to where you want to be!",
      goalResult: "Here you can enter your assessment of the result and justify why the goal has been reached or not.",
      departmentForUser:
        "You can add a user to a department if the organization has departments. You can add these in the section below. In the organization overview, you can see results for each department.",
      roleForUser:
        'The roles determine the access the user has to the content in the organization. The owner has access to everything, while supporters can see evaluations and improvement goals. Members can only see their own evaluations and goals, in addition to content that is shared with the entire organization. The role "Invited" can not see anything until they have become members.',
      groupsForUser:
        "If the roles do not provide enough control, you can create your own groups and add users to these. It is possible to give access to evaluations and improvement goals based on groups, for even better control.",
    },
    goalHelp: {
      heading: "Help",
      aboutTo:
        "You are about to create an improvement goal. Review the results of one of your completed surveys and find out what you want to improve on. Choose the categories, create a plan a start executing!",
      phases: "The improvement goal has three phases: Initial phase, execution phase and conclusion phase.",
      initialPhase: "In the initial phase, the focus is to describe the starting situation and create a plan for how to achieve the goal.",
      executionPhase:
        "The execution phase is about following up on the plan, create new surveys and measure the changes in results. You should write a journal during this phase, adding activities, reflections and new learnings along the way.",
      conclusionPhase:
        "The conclusion phase becomes available one week after the end date of the goal. Here you should evaluate the changes in survey results, write down your reflections and decide if the goal was a success or not. If you want to, you can also start a new goal directly from the latest survey!",
      acheivement:
        "We are not asking you to quantify the goals. Because it is continuous improvement, it is more important that you are going in the right direction. Then you will surely reach your potential within a couple of rounds.",
      goodLuck: "Good luck!",
    },
    surveyInfo: {
      heading: "Help",
      aboutTo:
        "You are about to create a survey. It will consist of four questions that will give you a measure of customer satisfaction within long-term assignments, courses or workshops, or service deliveries.",
      invitations: "You need to enter names and an invitation text, and you will see a preview of the email that will be sent to those you invite.",
      emailSend:
        "If you choose to invite someone right away, the email will be sent as soon as you complete the registration. If not, you can invite people later.",
      access: "Finally, you will be asked to enter some information about who should have access, and how long the survey should last.",
      slowInvites: "Note! If you have invited many, it may take some time to create the survey.",
      goodLuck: "Good luck!",
      finished1: "This survey is finished, and responders can no longer answer it, even though they have received an invitation. The scores will not change.",
      finished2:
        "It is time to evalute the results and add your reflections. If there is something you want to impove, you should consider to create an improvement goal!",
      ongoing1: "This survey is ongoing, and you can invite new responders. They must answer before the end date, and their answers will appear immediately.",
      ongoing2: "It may be a good idea to remind those who have not answered. Even though it is quick to answer, many postpone, and forget it.",
    },
    smileyFaceRating: {
      ratingInfo:
        "We in Feedback Journey love feedback, and we would really appreciate what you think about our solution to collect feedback. Please rate us with a smiley face, and let us know what you think.",
      receipt: "Thank you for your feedback!",
    },
    join: {
      aboutTo: "You are about to join the organization {1}",
      join: "Join {1}",
      joinFailed: "Could not join the organization. Please try again or contact support.",
      orgFetchError: "Could not fetch organization data. Please try again or contact support.",
      joinByLinkHeading: "Join an Organization",
      pasteLink: "Do you have an invitation link? Paste it here",
      okButton: "OK",
      joining: "Joining...",
    },
    misc: {
      serverError: "An error occurred. Please try again or contact hei@feedbackjourney.com",
      languageSelectorLabel: "Language",
      copyToClipboard: "Copy",
      copiedToClipboard: "Copied to clipboard",
      moreInfo: "More information",
      errorCopying: "Copying to clipboaard failed",
    },
    subscription: {
      activateSub: "Activate subscription",
      stripeInfo:
        "Feedback Journey uses Stripe for payments. By clicking on the button below, you will be sent to Stripe where you can manage the subscription, payments and download invoices.",
      subscriptionOrderText: "Start a new 12-month period with evaluations and continuous improvement",
      subscriptionOrderInfo: "You will be sent to Stripe to complete the payment.",
      goToCheckout: "Go to checkout",
      subscriptionActivatedHeading: "Subscription activated",
      settingsHeading: "Subscription",
      detailsHeading: "Subscription Details",
      startDateLabel: "Start date",
      endDateLabel: "End date",
      renewalDateLabel: "Renewal date",
      cancelSubscription: "Cancel subscription",
      cancelConfirm: "Are you sure you want to cancel? Your subscription will remain active until the end of the current period.",
      cancelSuccess: "Your subscription has been cancelled and will not renew.",
      subscriptionStatus: "Status",
      status_active: "Active",
      status_undefined: "No active subscription",
      status_none: "No active subscription",
      status_ended: "Expired",
      status_created: "Created",
      subscriptionType: "Type",
      type_trial: "Individual (trial)",
      type_recurring: "Individual",
      type_org: "Organization",
      type_none: "None",
      openPortal: "Manage subscription",
      subscriptionActivatedSuccess: "The subscription is now activated",
      subscriptionActivationError: "There was an error when we tried to activate the subscription. Please try again, or contact support.",
      checkoutCancelled: "The checkout was cancelled. Please activate a subscription in order to continue using Feedback Journey.",
    },
    orgDash: {
      scoreHeading: "Organization Score",
      surveyTypeHeading_delivery: "Survey Type - Service Delivery",
      "surveyTypeHeading_long-term": "Survey Type - Long Term Assignment",
      surveyTypeHeading_workshop: "Survey Type - Workshop or Course",
      orgScoreInfo: "These values show the score across all of the organizations surveys, not including private surveys.",
      periodForever: "Since the start",
      periodYear: "Last 12 month",
      period6m: "Last 6 months",
      period3m: "Last 3 months",
      periodLabel: "Select period",
      periodInterval: "Choose from and to dates",
      answersLabel: "Answers",
      surveyLabel: "Surveys",
      updateBtn: "Update",
      toDate: "To",
      fromDate: "From",
      candidatePlaceholder: "[name of consultant]",
      departmentLabel: "Department",
    },
    comments: {
      addCommentHeading: "Add comment",
      fieldRequired: "Can not post empty comment",
      serverError: "We could not save your comment. Please try again or contact support.",
      submit: "Save comment",
      formErrors: "Missing comment",
    },
    aiCoach: {
      buttonLabel: "AI coach",
      heading: "Generate AI comment",
      info: "You can get an AI-generated comment that can help you discover patterns in the answers, and give you suggestions on what to focus on to improve.",
      dataNotice: "You might want to add or update your reflections and notes before you generate the AI comment, to get the best possible suggestions.",
      dataSources: "The AI coach can give a comment based on your results, comments, messages and recommendations in this evaluation.",
      aiDisclosure: "To create the suggestion, this content is sent to our AI provider, Google Gemini. See our privacy policy for details.",
      confirm: "Generate",
      cancel: "Cancel",
      loading: "Generating... You may leave this page in the meantime.",
      writingBoth: "Rhys and Lisa are writing",
      writingLisa: "Lisa is writing",
      error: "Could not generate AI comment. Please try again.",
    },
    improvementGoals: {
      noSelectedCategories: "No categories selected",
      noSharedGoals: "There are no improvement goals that has been shared with you yet.",
      noGoals: "You have not created any improvement goals yet. Start with a survey and set an improvement goal based on the results from it.",
      editOrgHeading: "Edit Organization Goal",
      orgHeadingCreate: "Create an Organization Goal",
      create: "Create improvement goal",
      missingOriginalSurvey: "The goal needs to be created from a survey. Start form from a completed survey and try again.",
      fieldRequired: "This field is required",
      heading: "Create improvement goal",
      goalHeading: "Improvement goal",
      editHeading: "Edit improvement goal",
      knowledgeLabel: "Knowledge",
      knowledgeSharingLabelLong: "Knowledge sharing",
      knowledgeSharingLabel: "Sharing",
      expectationsLabel: "Expectations",
      influenceLabel: "Social",
      collaborationLabel: "Collaboration",
      subjectKnowledgeLabel: "Knowledge",
      qualityLabel: "Quality",
      communicationLabel: "Communication",
      expertiseLabel: "Expertise",
      engagingLabel: "Engaging",
      relevanceLabel: "Relevance",
      satisfactionLabel: "Satisfaction",
      categoriesLabel: "Choose improvement categories",
      name: "Give your goal a name",
      endDate: "When do you want your goal to be achieved (recommended 6 months)",
      goal: "Describe your goal",
      situation: "Describe the starting situation",
      plan: "Describe your execution plan to achieve the goal",
      result: "Describe the result of the work during the period of the goal",
      submit: "Create goal",
      submitEdit: "Update goal",
      serverError: "We could not save your goal. Please try again or contact support",
      accessibleBy: "Accessible by",
      accessibleByMe: "Only me",
      accessibleBySupporters: "Supporters",
      accessibleByOrganization: "Everyone in the organization",
      goalDescriptionHeading: "Goal description",
      improvementCategories: "Improvement categories",
      initialSituationHeading: "Initial situation",
      planHeading: "Execution plan",
      registeredLabel: "Started: {1}",
      endDateLabel: "End date: {1}",
      sharedGoalsTitle: "Shared improvement goals",
      goalsTitle: "Improvement goals",
      originalSurvey: "Original survey",
      latestSurvey: "Latest survey",
      phasesInitial: "1. Planning",
      phasesExec: "2. Execution",
      phasesConclusion: "3. Conclusion",
      latestSurveys: "Latest surveys",
      createSurvey: "Create a new survey",
      comments: "Comments",
      conclusionHeading: "Conclusion",
      statusongoing: "Ongoing",
      statusfinished: "Finished",
      noRecentSuveys: "There are no suveys created after the start of the goal",
      conclusionEditHeading: "How did it go?",
      submitConclusion: "Save changes",
      isSuccessLabel: "Would you say that the goal was achieved?",
      isSuccessYes: "Yes",
      isSuccessNo: "No",
      success: "Success",
      fail: "Failure",
      journalHeading: "Journal",
      patienceConclusion: "Conclusion tab will become available towards the end of the goal period",
      emptyConclusion: "Edit goal to add your conclusion thoughts",
      status_finished: "Status: Finished",
      status_planning: "Status: Planning",
      status_conclusion: "Status: Conclusion",
      status_execution: "Status: Execution",
      createNewGoal: "Create a new improvement goal",
      sharedBy: "Shared by {1}",
      orgRecentSurveyResults: "Recent survey results",
      orgResultsFromTo: "Results from {1} to {2}",
      orgOriginalResultsFromTo: "Original Results from {1} to {2}",
      totalSurveys: "Surveys",
      totalAnsvars: "Answers",
      orgGoalCategoriesPeriod: "Results from last six months",
      backToGoals: "Back to improvement goals",
      backToOrganization: "Back to organization",
      categoryBadge: "Category: {1}",
      editGoal: "Edit goal",
      startLabel: "Start {1}",
      endLabel: "End {1}",
      phasesHeading: "Phases",
      phasePlanningText: "Describe the goal, the situation and the plan.",
      phaseExecutionText: "Follow the plan, write in the journal and ask for feedback.",
      phaseConclusionText: "Look back and decide whether the goal was reached.",
      goalCardHeading: "Goal",
      situationCardHeading: "Situation",
      planCardHeading: "Plan",
      colSurvey: "Survey",
      colLastResponse: "Last response",
      colRespondents: "Respondents",
      baseline: "Baseline",
      open: "Open",
      movementUp: "Up since the baseline: {1}.",
      movementDown: "Down since the baseline: {1}.",
      movementSame: "Unchanged: {1}.",
      movementOpen: "{1} surveys are still open, so the numbers can change.",
      nextSurveyHeading: "Next survey",
      nextSurveyText: "A new survey shows whether the plan is working.",
      successHeading: "What counts as success",
      successText1: "The assessment is qualitative, and it is yours to make.",
      successText2: "Small improvements count.",
      successText3: "Your next goal starts from the latest survey.",
      sharedWithHeading: "Shared with",
      coachHeading: "Your coach",
      coachName: "Lisa Hauge",
      coachText: "Lisa reads the goal, the plan and the journal, and answers in the journal.",
      askCoach: "Ask Lisa",
    },
    systemMessages: {
      loading: "Loading data...",
      contactFormError: "There was an unexpected error when sending the form. Please try again.",
      joinFailed: "Could not join the organization. Please try again or contact support.",
      orgFetchError: "The URL you searched for is not valid. Please correct the URL and try again.",
      notFound: "The content you are looking for could not be found",
      surveyEnded: "This survey is regrettable finished",
      alreadyResponded: "You have already responded to this survey",
      login: "Logging in...",
      errorLogin: "Login failed...",
      verifyEmail: "You need to verify your email address. Check your email and log in again.",
      invalidDomain:
        "Feedback Journey a solution for organizations, and the users are connected using the email domain. The domain you have used to log on with is shared with others, and can unfortunately not be used.",
    },
    userManagementForm: {
      name: "Name",
      department: "Department",
      role: "Role",
      departmentDeleted: "{1} was deleted",
      title: "Users",
      roleOwner: "Administrator",
      roleMember: "Member",
      roleInvited: "Invited",
      roleSupporter: "Supporter",
      departmentsTitle: "Departments",
      noDepartments: "No departments are added",
      editDepartment: "Edit departments",
      addDepartment: "Add a department",
      departmentNameLabel: "Add department",
      submit: "Save",
      noDepartment: "No department",
      goBack: "Close",
      invalidDepartment: "You need to provide a name for the department",
      inviteUsersTitle: "Invite users",
      inviteUsersDescription: "You can invite users from your organization by sharing the link below with them.",
      editGroups: "Add or remove groups",
      addGroup: "Add groups",
      editGroup: "Edit groups",
      groupNameLabel: "Group name",
      invalidGroup: "You need to provide a name for the group",
      memberOf: "Member of",
      availableGroups: "Other groups",
      groupsHeading: "Groups",
      save: "Save",
      accessFor: "Accessible by",
      noGroups: "The organization has no groups yet",
      inviteUsersInfo:
        'Everyone with the link can join the organization. They will have the role "Invited" when they join. With this role they won\'t be able to access anything within the organization. When they have joined, you will have to give them the role "Member" or "Supporter" for them to have access to the organization\'s content.',
      groupsInfo:
        "Groups are a way to organize users in the organization. You can give access to content based on groups, for example evaluations and goals. In addition, you can see statistics for each group under the organization overview. Here you can add or remove groups, which you can later connect users to from the user list above.",
      departmentsInfo:
        "Departments are a way to organize users in the organization. You can see statistics for each department under the organization overview. Here you can add or remove departments, which you can later connect users to from the user list above. A user can only belong to one department.",
    },
    cardForm: {
      survey: "Survey",
      firstSurvey: "First survey",
      lastSurvey: "Last survey",
      chooseSurvey: "Choose a survey",
      rangeLabel: "Surveys on the card",
      rangeSummary: "{1} surveys, {2} answers",
      rangeAllIncluded: "Every survey between the first and the last is included. None can be left out.",
      surveyTypeFilterLabel: "Survey type",
      cardTitle: "Text on the card",
      noCards: "You have not created any Journey cards yet",
      noSharedCards: "There has not been created any Journey cards yet.",
      loadCardsError: "We could not load your Journey cards. Please reload the page or try again later.",
      startingSurvey: "From, and including",
      endingSurvey: "To, and including",
      heading: "Create Journey Card",
      onlyOneCard: "You need to register- or join an organization to create more Journey cards.",
      preview: "Preview",
      createCard: "Create new Journey Card",
      serverError: "We could not save your card. Please try again or contact support",
      imageNotReady: "The preview is still being prepared. Wait a moment and try again.",
      selectSurveyInfo: "Select the interval of surveys that are to be included in the card.",
      surveys: "Surveys",
      selectedHeading: "Survey interval",
      submit: "Create card",
      invervalError: "You need to select to- and from evaluation. It can be the same.",
      noSurveys: "You have not had any surveys yet. You need to have at least one survey to create a Journey card.",
      exposeDomains: "Show responder domains on public card",
      "help.exposeDomains": "If turned off, the public view of this Journey Card will not show the responders' email domains.",
      groupsHeading: "Who in the organisation sees the card",
      groupsHelp: "With no groups selected, everyone in the organisation sees the card under shared cards. The public link to the card works as before.",
      recommendationsHeading: "Recommendations on the card",
      recommendationsInfo:
        "You can pick up to {1} of the recommendations given in the surveys above. They are shown below the card — the responder's name and title, never their email address.",
      noRecommendations: "No recommendations were given in the surveys you selected.",
      recommendationsSelected: "{1} of {2} selected",
      recommendationsLimitReached: "{1} of {1} selected. Unselect one to pick another.",
    },
    menu: {
      settings: "Settings",
      createSurvey: "Create a survey",
      contact: "Contact and Support",
      role_owner: "Administrator",
      role_supporter: "Supporter",
      role_undefined: " ",
      role_member: "Member",
      role_invited: "Invited",
      role_none: " ",
      surveys: "Surveys",
      sharedSurveys: "Shared surveys",
      sharedCards: "Shared cards",
      card: "Journey cards",
      logout: "Log out",
      goals: "Improvement goals",
      sharedGoals: "Shared improvement goals",
      orgDash: "Organization Dashboard",
      myFeedbach: "My Journey",
      sharedFeedbach: "Shared Journey",
      notifications: "Notifications",
      openMenu: "Open menu",
      openNavigation: "Open navigation",
      unreadNotifications: "You have {1} unread notifications",
      dashboard: "Dashboard",
      navigation: "Main menu",
      subscriptionActive: "Subscription active",
      subscriptionTrial: "Trial period",
      subscriptionInactive: "No active subscription",
    },
    notifications: {
      heading: "Notifications",
      empty: "You have no notifications.",
      loading: "Loading notifications...",
      markAllRead: "Mark all as read",
      type_response: "A new response has been received on your survey",
      type_survey_comment: "A new comment was added to your survey",
      type_goal_comment: "A new comment was added to your improvement goal",
      type_survey_ended: "Your survey has ended",
      type_goal_ended: "Your improvement goal period has ended",
    },
    settings: {
      heading: "Settings",
      profileImageHeading: "Change profile image",
      saveImageBtn: "Save",
      imageMissing: "You need to choose an image",
      existingImage: "Existing profile image",
      profile: "Profile",
      organization: "Organization",
      members: "Users and roles",
      dataPrivacy: "Privacy",
      detailsHeading: "Subscription Details",
    },
    dataPrivacy: {
      heading: "Data & privacy",
      exportHeading: "Download your data",
      exportDescription:
        "Get a copy of your personal data — your profile, surveys, the responses you received, Journey Cards, improvement goals and a billing summary — as a JSON file.",
      exportButton: "Download my data",
      exporting: "Preparing your data…",
      exportError: "We couldn't prepare your data right now. Please try again.",
      deleteHeading: "Delete your account",
      deleteDescription:
        "This permanently deletes your account and all of your feedback data: your profile, surveys, the responses you received, comments, improvement goals and Journey Cards. This cannot be undone.",
      deleteRetentionNote:
        "Billing and accounting records are kept where the law requires it. Any active subscription is cancelled and your saved payment details are removed.",
      deleteOrgNote:
        "If you own an organization that still has other members, ownership is transferred to another member so they keep their access.",
      confirmLabel: "Type your email address ({1}) to confirm",
      confirmPlaceholder: "your@email.com",
      deleteButton: "Delete my account",
      deleting: "Deleting your account…",
      deleteError: "We couldn't delete your account right now. Please try again or contact support.",
      finalConfirm:
        "This permanently deletes your account and all of your feedback data. This cannot be undone. Continue?",
      noEmailError:
        "Your account has no email on file, so we can't verify deletion here. Please contact hey@feedbackjourney.com.",
    },
    frontpage: {
      subTitle: "Knowledge bank for continuous improvement!",
    },
    dashboard: {
      title: "Overview",
      seeMoreRecommendations: "See more recommendations",
      latestCard: "Latest Journey Card · {1}",
      cardSummary: "Covers {1} surveys from {2} to {3}, with {4} responses. Latest response {5}.",
      downloadCard: "Download card",
      openLiveCard: "Open live card",
      createCard: "Create a new card",
      noCardEyebrow: "Journey Card",
      noCardTitle: "Create your first Journey Card",
      noCardBody: "A Journey Card gathers the scores from your surveys in one card you can share with customers and on LinkedIn.",
      createFirstCard: "Create a Journey Card",
      yearTitle: "Your journey this year",
      yearSurveys: "Surveys",
      yearResponses: "Responses",
      yearGoals: "Goals",
      alertStreak: "{1} has been the lowest category in {2} surveys in a row. Create an improvement goal.",
      alertFollowUp: "{1} has just finished. A follow-up meeting is recommended.",
      alertRecommendations: "You have {1} recommendations you can quote.",
      seeAllSurveys: "See all surveys",
      phase_planning: "Planning",
      phase_execution: "Execution",
      phase_conclusion: "Conclusion",
      phase_finished: "Finished",
      goalSuccess: "Success",
      goalFailure: "Failure",
      goalFromSurvey: "From {1}",
      expiredSubTitle: "It seems like the subscription has expired!",
      expiredSubBody: `You can still look around, but you can't create new surveys. Click the button below to renew your subscription.`,
      expiredSubBodyNotOwner: `You can still look around, but you can't create new surveys. Please contact the owner of the organization.`,
      noSubTitle: "Could not find an active subscription!",
      noSubBody: `You can still look around, but you can't create new surveys. Click the button below to activate a subscription.`,
      trialExpiredSubTitle: "It seems like the trial period has expired.",
      trialExpiredSubBody: `You can still look around, but you can't create new surveys. Click the button below to activate a subscription.`,
      activeSubscription: "Active subscription",
      noOrgTitle: "You are now in a trial period",
      joinOrganization: "Join an Organization",
      noOrgDescription: "You have some limitations in number of surveys and invited users. Register to get the full experience of Feedback Journey.",
      pendingApprovalTitle: "Waiting for approval",
      pendingApprovalBody: "The owner of {1} must approve your request before you get access to the organization.",
      noOrgButton: "Organization Plan",
      registerSingle: "Single User Plan",
      welcomeTitle: "Welcome to Feedback Journey!",
      welcomeMessage:
        "Your profile has been created successfully. You're now ready to start creating surveys, setting goals, and collecting valuable feedback to drive continuous improvement in your organization.",
    },
    orgForm: {
      title: "Register your organization",
      uploadLogo: "Upload company logo",
      updateTitle: "Update Organization Data",
      orgName: "Organization name",
      orgNo: "VAT number",
      country: "Country",
      submit: "Submit",
      domain: "Domain - Users with email on this domain will be added to the organization",
      fieldRequired: "This field is required",
      formErrors: "Oops, there are some errors here",
      logoLabel: "Upload company logo",
      logoAlt: "Organization logo",
      receiptText: "Company information was updated",
      consentToTerms: "I consent to the terms of the data processing agreement",
      termsLink: "Read the terms of the data processing agreement",
      consentToTermsRequired: "You need to accept the data processing agreement",
      consentToAgreement: "I accept the terms of the general agreement",
      consentToAgreementRequired: "You need to accept the content of the general agremeent",
      agreementLink: "Read the general agreement",
      allowPrivateSurveys: "Allow private surveys",
      allowPrivateSurveysInfo:
        "If you allow private surveys, users in the organization can create surveys that are not visible to anyone but themselves. This is useful if the users are reluctant to share their feedback, at least until the answers are in. It also prevents key account managers from seeing the feedback from their own customers.",
      orgSettingsHeading: "Organization settings",
    },
    surveys: {
      title: "Surveys",
      onlyOneSurvey: "You need to register- or join an organization to create more surveys.",
      noSurveys: "You have not created any surveys yet.",
      noSharedSurveys: "No surveys have been shared with you yet.",
      responderNotesHeading: "Notes",
      submitResponderNotes: "Save",
      noResponderNotesText: "No notes are added",
      listItemHeading: "Survey",
      ends: "ends",
      respondents: "Respondents: {1}/{2}",
      start: "Start: {1}",
      end: "End: {1}",
      changed: "Changed {1}",
      status_upcoming: "Status: Upcomming",
      status_ongoing: "Status: Active",
      status_finished: "Status: Finished",
      surveyHeading: "Survey {1}-{2}",
      titleNameOngoing: "{1}, ongoing until {2}",
      titleNameFinished: "{1}, ended {2}",
      titleFinished: "Survey, ended {1}",
      titleOngoing: "Survey, ongoing until {1}",
      createSurvey: "Create new survey",
      reflectionsHeading: "Reflections",
      noReflectionsText: "No reflections added",
      submitReflections: "Save reflections",
      editSurvey: "Edit survey",
      sharedBy: "Shared by",
      creator_onBehalfOf: "Created by",
      creator_for: "for",
      sharedHeading: "Shared surveys",
      followUpMeetingRecommendation:
        "The survey ended recently. Consider scheduling a follow-up meeting with your employer, team lead, or colleagues to discuss the results and set improvement goals.",
      backToSurveys: "Back to surveys",
      backToShared: "Back to shared surveys",
      setImprovementGoal: "Set an improvement goal",
      tabsLabel: "Survey results",
      tabSummary: "Summary",
      tabResponses: "Responses ({1})",
      tabReflections: "Reflections",
      tabNotes: "Notes",
      totalScore: "Total score",
      answersCount: "{1} answers",
      dontKnowsCount: "{1} don't know",
      previousSurvey: "Previous survey: {1}",
      previousScore: "Previous: {1}",
      lowestStreak: "Lowest {1} surveys in a row",
      strongScore: "An 8 is a strong score here. Responders save a 10 for world-class work.",
      mayQuote: "You may quote this",
      accessHeading: "Who can see this",
      sharedWithGroups: "Shared with: {1}",
      nothingPublished: "Nothing is published until you create a Journey Card.",
      shareWithGroup: "Share with a group",
      eligibleForCard: "Eligible for a Journey Card",
      coachHeading: "AI coach",
      coachNames: "Rhys and Lisa",
      coachRhys: "Rhys",
      coachLisa: "Lisa",
      askCoach: "Ask the coaches",
    },
    questions: {
      knowledge: "How would you rate the professional skills of {1}?",
      knowledgeInfo: `How is the worker's knowledge within the field of expertise compared to what has been promised or your expectations? How is the worker's abilities to get acquainted with your needs?`,
      knowledgeSharing: "How would you rate the ability of {1} to share her/his knowledge and experiences?",
      knowledgeSharingInfo: `Does the worker contribute with her/his experiences and knowledge in a constructive way to provide solutions to your needs?`,
      influence: "How would you rate the contributions of {1} to the working environment?",
      influenceInfo: `To what degree does the worker participate and contribute to the social environment in your work place?`,
      collaboration: "How would you rate the collaboration skills of {1}?",
      collaborationInfo: `How easy is it to collaborate with the worker, and how is the contribution within- and among the teams of the organization?`,
      subjectKnowledge: "How would you rate the professional knowledge of {1} on the subject that was presented?",
      subjectKnowledgeInfo: `What was the level of expertise within the subject that was presented? Was the content presented in a way that was easy to understand, and was it possible to get answers to questions?`,
      engaging: "How would you rate communication skills of {1}?",
      engagingInfo:
        "Was the content presented in an engaging manner, and was it possible to actively participate in the course/workshop? How did you experience the learning process?",
      relevance: "How relevant and useful was the content of the course/workshop to your needs?",
      relevanceInfo: "Was the course/workshop relevant compared to what you expected? Was the information up-to-date and useful?",
      satisfaction: "How would you rate your overall satisfaction with the course/workshop delivered by {1}?",
      satisfactionInfo: "Did the course/workshop meet your expectations?",
      expertise: "How would you rate the professional competence and expertise of {1}?",
      expertiseInfo:
        "How is the consultant's knowledge within their area of expertise compared to your expectations? How is the consultant's ability to understand your needs?",
      communication: "How satisfied are you with the communication and availability of {1} throughout the project?",
      communicationInfo: "Did you feel that your questions were answered without having to wait too long? Were the consultant's promises fulfilled?",
      expectations: "How well did you feel that {1} understood and met your needs and expectations?",
      expectationsInfo: "Was the delivery as you expected, and would you use the same service again?",
      quality: "How would you rate the overall quality of the service delivered by {1}?",
      qualityInfo: "Did you find the service to be of high quality and that the consultant delivered what was promised, to the standard you expected?",
      summary: "Summary",
      totalScore: "Total score",
      invitedHeading: "Invited",
      recommendationsHeading: "Recommendations",
      messagesHeading: "Feedback messages",
      resultAnswers: "Number of answers: {1}",
      resultDontKnows: `Number of don't knows: {1}`,
      responseHeading: "Response from {1}",
      anonymousName: "anonymous",
      recommendationHeading: "Recommendation!",
      messageHeading: "Feedback",
      answersHeading: "Answers",
      commentsHeading: "Notes and comments",
      messageColumn: "Message",
      columnHeading: "From",
      dontKnow: "Don't know",
      unanswered: "Not answered",
      hasNotResponded: "{1} has not responded yet.",
      knowledgeLabel: "Knowledge",
      knowledgeSharingLabel: "Knowledge Sharing",
      influenceLabel: "Social",
      collaborationLabel: "Collaboration",
      subjectKnowledgeLabel: "Knowledge",
      engagingLabel: "Engaging",
      relevanceLabel: "Relevance",
      satisfactionLabel: "Satisfaction",
      qualityLabel: "Quality",
      expectationsLabel: "Expectations",
      communicationLabel: "Communication",
      expertiseLabel: "Expertise",
      score10:
        "Score is {1}, meaning that the worker is absolutely world class. You should save the 10 for a very special occasion. Are you sure there are no areas for improvement?",
      score9: "Score is {1}, meaning that the worker is excellent. Performance on this level is unusual. Are you sure there are no areas for improvement?",
      score7to8: "Score is {1}, meaning that the worker is great. This is a good score, and the worker is doing a great job.",
      score5to6:
        "Score is {1}, meaning that the worker is good. This is an average score, and the worker is doing OK, however there are some areas that could be improved. Maybe you should let the worker know what you think in the notes and comments?",
      score1to4:
        "Score is {1}, meaning that the worker is not good. This is a low score, and the worker is not meeting the expectations. Maybe you should let the worker know what you think in the notes and comments?",
      feedbackFromHeading: "Feedback from {1}",
    },
    surveyForm: {
      allowAnonymous: "Do you want to allow anonymous respondents for this survey?",
      allowAnonymousInfo:
        "If you allow anonymous respondents, you will get a link that you can share with anyone. The answers will be anonymous, and you will not know who has answered. This can be especially useful for courses and workshops where participants can respond immediately after the event.",
      showRecommendation: "Show the recommendation section in the response form",
      showRecommendationInfo:
        "If you disable this, responders will not be asked for recommendations. Any recommendations that have already been submitted will still be visible in the survey details.",
      surveyTypeLongTerm: "Long term assignment",
      surveyTypeWorkshop: "Workshop or course",
      surveyTypeDelivery: "Service delivery",
      surveyTypeLabel: "Survey type",
      surveyTypeNoChange: "The survey type can not be changed after the survey is created.",
      selectedSurveyTypeQuestions: "The type you have selected will have the following questions:",
      heading: "New survey",
      invitesHeading: "Invite responders",
      invitesInfo:
        "By adding the email addresses of your colleagues and other collaborators, they will receive an email with a link to the response form when you finish this wizard. You can specify the language of the email and response form for each invite.",
      skipForLater: "You may skip this step and return to it later, when the survey is created.",
      emailPreviewTitle: "Invitation email preview",
      emailPreviewInfo:
        "When you invite responders, they will receive an email with a link to the response form. The email will look like this, and include your own invitation text.",
      next: "Next",
      surveyAccessStep: "Access",
      previous: "Previous",
      editHeading: "Edit the Survey",
      defaultLang: "Standard language",
      candidate: "Your name (on the invitation)",
      startDate: "Start date",
      endDate: "End date",
      invitationText: "Invitation text",
      submit: "Create survey",
      submitEdit: "Save changes",
      fieldRequired: "This field is required",
      dateLogic: "End date must be later than start date",
      minimumDuration: "End date must be more than one week ahead",
      formErrors: "Oops, there are a few answers missing",
      serverError: "There was an error when we tried to store your survey. Please try again, or send an email about the problem to hello@feedbackjourney.com",
      surveyName: "Survey name",
      accessibleBy: "Accessible by",
      accessibleByMe: "Only me",
      accessibleBySupporters: "Supporters",
      accessibleBySelectedGroups: "Selected groups",
      accessibleByOrganization: "Everyone in the organization",
      onBehalfOf: "Create survey on behalf of",
      accessHeading: "Survey Access",
      groupsHeading: "Give access to groups",
    },
    invites: {
      title: "Invite responders",
      emailsLabel: "Add the email addresses here",
      showMultiInput: "Add multiple emails",
      hideMultiInput: "Add emails one by one",
      hasBeenResent: "Resent",
      notSent: "Not sent",
      resendInvite: "Resend",
      anonymousInvites: "Anonymous responders",
      languageLabel: "Language",
      anonymousInfo:
        "This survey accepts anonymous responders. You can share the link below with anyone, and they can respond without you knowing who they are.",
      new: "Invited",
      serverError:
        "There was an error when we tried to send the invitation. Make sure the email addresses are correct and are not already invited, and try again.",
      en: "English",
      no: "Norwegian",
      responded: "Has answered",
      emailed: "Has received email",
      submit: "Invite",
      emailLabel: "E-mail",
      invitedHeading: "Invited",
      invitationTextHeading: "Invitation text",
      invalidEmail: "The e-mail address is not valid",
      maxEmailsExceededNoOrg: "You have reached the maximum number of invites. Please register an organization to invite more people.",
      maxEmailsExceeded: "You have reached the maximum number of invites.",
      invitesInfo:
        "We recommand that you discretely follow up your invites. If they do not respond after some time, you should ask them if they received the invitation, and have them check their spam folder.",
    },
    responderForm: {
      allQuestionsRequired: "All questions must be answered. Choose a number, or I don't know.",
      questionOf: "Question {1} of {2}",
      lastStep: "Last step",
      lastStepHeading: "Anything else you would like to tell {1}?",
      progress: "Progress",
      next: "Next",
      previous: "Back",
      messagePlaceholder: "What works well, and what could {1} do even better? Concrete examples help the most.",
      readByRecipient: "{1} reads the answers personally.",
      poweredBy: "Powered by",
      anonymousResponderInfo: "You respond anonymously",
      responsesNotAnonymous: "Your response is not anonymous. {1} will be able to identify you based on the link you used.",
      title: "Survey for",
      giveRecommendation: "Would you like to give a recommendation?",
      recommendationName: "What is your name?",
      recommendationNameInfo: "We ask for your name and title to add credibility when the recommendation is presented in CVs, etc.",
      recommendationTitle: "What is your title?",
      invitationHeading: "Invitation",
      messageLabel: "Additional feedback (optional)",
      recommendationLabel: "Recommendation",
      recommendationInfo:
        "If you want, you can include a recommendation with your name and title. {1} can then use it in marketing, such as CVs, web pages and offers.",
      submit: "Send",
      allQuesstionsRequired: "This question must be answered",
      formErrors: "Oops, there are a few answers missing",
      serverError: "There was an error when we tried to store your answers. Please try again, or send an email about the problem to hello@feedbackjourney.com",
      thankYouHeading: "Thank you!",
      receiptText:
        "Your answers are greatly appreciated and valuable. If there are additional information you would like to add, please reach out to {1} and talk about it.",
    },
    card: {
      registered: "Registered {1} - ",
      visits: "Opened {1} times, {2} from QR code",
      visitsHelp:
        "The number counts all traffic to the card: people, but also search engines, bots and link previews in for example LinkedIn and Slack. The QR number counts visits from a scanned QR code.",
      verifiedHeading: "Verified by Feedback Journey",
      verifiedSeries: "The card covers every survey from the first to the last. None can be picked out, so a strong card means strong results across the whole period.",
      verifiedEyebrow: "Verified by Feedback Journey",
      verifiedBuiltOn: "What this card is built on",
      surveyAnswers: "· {1} answers",
      surveyPeriod: "{1} to {2}",
      publicChip: "Verified Journey Card",
      publicHeading: "Client feedback for {1}, checked against the original answers.",
      publicSummary: "{1} answers from {2} surveys, {3} to {4}. Feedback Journey holds the responses, so the scores on this page cannot be edited or picked from.",
      howVerificationWorks: "How verification works",
      createOwnCard: "Create your own Journey Card",
      copyCardLink: "Copy link to this card",
      cardLinkCopied: "Link copied",
      publicRecommendationsEyebrow: "Recommendations",
      publicRecommendationsHeading: "In the clients' own words",
      publicRecommendationsLead: "Written by responders in the surveys above, published with their consent.",
      ctaHeading: "A Journey Card is proof you can put on a CV or in a proposal.",
      ctaBody: "Send short surveys to your clients along the way. Feedback Journey collects the answers and turns the whole series into a card nobody can edit.",
      ctaButton: "Create your first survey free",
      ctaLink: "How the verification works",
      footerCompany: "Feedback Journey, Aiga AS",
      footerOwner: "The card owner decides what is shared and can unpublish it at any time.",
      footerPrivacy: "Privacy",
      footerReport: "Report a card",
      verifiedSurveys: "Surveys included",
      verifiedDomains: "Answers from",
      anonymousResponders: "Anonymous",
      anonymousDomain: "Anonymous",
      noOfResponders: "Number of answers",
      latestResponse: "Latest answer",
      scanToVerify: "Scan to verify",
      verifiedCard: "Verified card",
      answersPill: "{1} answers",
      latestPill: "Latest {1}",
      surveysPill: "{1} surveys",
      totalScoreLabel: "Total",
      knowledgeLabel: "Knowledge",
      sharingLabel: "Sharing",
      knowledgeSharingLabel: "Sharing",
      influenceLabel: "Social",
      collaborationLabel: "Collaboration",
      subjectKnowledgeLabel: "Subject Knowledge",
      engagingLabel: "Engaging",
      relevanceLabel: "Relevance",
      satisfactionLabel: "Satisfaction",
      qualityLabel: "Quality",
      expectationsLabel: "Expectations",
      communicationLabel: "Communication",
      expertiseLabel: "Expertise",
      cardStatsHeading: "Journey Card Info",
      responderDomains: "Responder domains",
      uniqueResponders: "Unique responders",
      earliestResponse: "Earliest response",
      statsLatestResponse: "Latest response",
      moreInfo: "More info",
      noOfSurveys: "Number of surveys",
      recommendationsHeading: "Recommendations",
    },
    createProfile: {
      serverError: "An error occurred when saving the profile. Please try again.",
      nameMissing: "Full name is required.",
      candidate: "Full name",
      title: "Job title",
      heading: "Create your profile",
      saveBtn: "Create profile",
      profileImageLabel: "Profile image",
      profileImageAlt: "Profile image",
      editHeading: "Update profile",
      emailMissing: "The user you logged in with is missing email. Please contact support.",
      consentToTerms: "I accept the terms of the Agreement",
      consentToTermsRequired: "You need to accept the terms of the Agreement",
      termsLink: "Read the Agreement",
      uploadImage: "Upload profile image",
    },
    imageUploader: {
      chooseFile: "Drop the image here, or click to select from your computer",
      zoomLabel: "Zoom",
      cancel: "Cancel",
      submitImage: "Save image",
    },
    pricing: {
      heading: "Choose a plan",
      subheading: "Get the most out of Feedback Journey. Upgrade or join an organization at any time.",
      trialTitle: "Free Trial",
      trialPrice: "Free",
      trialPriceNote: "No credit card required",
      trialFeature1: "Up to 3 surveys",
      trialFeature2: "Up to 5 invited respondents",
      trialFeature3: "Access to all survey types",
      trialCta: "Continue with trial",
      singleTitle: "Single User",
      singlePriceYearly: "€67",
      singlePriceNoteYearly: "per year",
      singlePriceQuarterly: "€24",
      singlePriceNoteQuarterly: "per 3 months",
      singleBillingYearly: "Yearly",
      singleBillingQuarterly: "Quarterly",
      singleBadgeYearly: "Best value",
      singleFeature1: "Unlimited surveys",
      singleFeature2: "Unlimited respondents",
      singleFeature3: "Improvement goals & Journey cards",
      singleCta: "Get started",
      orgTitle: "Organization",
      orgPrice: "€1,500",
      orgPriceNote: "per year",
      orgFeature1: "Everything in Single User",
      orgFeature2: "Organization-wide dashboard",
      orgFeature3: "Department management",
      orgFeature4: "Role-based access control",
      orgCta: "Set up organization",
      orgOwnerOnly: "Only the owner of your organization can buy this plan.",
      joinOrganization: "Already have an invitation? Join an organization",
      vatNote: "All prices excl. VAT. Subscription billed via Stripe.",
      viewPlans: "View pricing plans",
    },
    announcements: {
      heading: "Announcements",
      empty: "There are no announcements at this time.",
    },
  } as const,
  no: {
    announcementBanner: {
      dismiss: "Lukk",
    },
    footer: {
      cookies: "Cookies",
      terms: "Vilkår",
      privacy: "Personvern",
      contact: "Kontakt",
    },
    contactUsForm: {
      heading: "Kontakt oss",
      messageLabel: "Hva kan vi hjelpe deg med?",
      submit: "Send",
      messageError: "Du må skrive en melding",
      receipt: "Takk for at du tok kontakt. Vi kommer tilbkae til deg så snart som mulig.",
    },
    coupons: {
      title: "Juletilbud",
      body: "Det er jul, og vi feirer ved å tilby 25% rabatt på første året. Aktivér ditt abonnement innen 14. desember og bruk følgende kode ved betaling:",
      button: "Start ditt abonnement",
    },
    screenshotView: {
      labelCanvas: "Lerret",
      labelFg: "Forgrunnsfarge",
      labelBg: "Bakgrunnsfarge",
      downloadImage: "Last ned",
      presetsTitle: "Fargepar",
      preset_cream: "Petrol på krem",
      preset_petrol: "Krem på petrol",
      preset_white: "Petrol på hvitt",
      preset_amber: "Petrol på rav",
    },
    help: {
      invitationText:
        "Denne blir inkludert i eposten og svarskjemaet. Du bør gjøre den personlig og forklare hvorfor du vil at respondenten skal svare på evauleringen.",
      surveyType:
        "Evalueringstypen bestemmer hvilke spørsmål som stilles til respondentene. Velg typen som best matcher arbeidsforholdet du har med respondenten.",
      onBehalfOf:
        "Fordi du har støttespiller- eller eierrollen kan du opprette evalueringer på vegne av andre. De vil få tilgang til den som om den er sin egen, men dere kan samarbeide om å invitere respondenter.",
      endDate: "Denne datoen bestemmer hvor lenge det skal være mulig å svare. Respondenter som ikke har svart innen denne datoen vil få en feilmelding.",
      defaultLang: "Denne setter stanradspråket for eposten og svarskjemaet, Den kan overstyres for hver enkelt invitasjon.",
      accessibleBy:
        "Her kan du velge hvem som skal kunne lese resultatene fra evalueringen. Du kan velge mellom deg selv, støttespillere, utvalgte grupper eller alle i organisasjonen. De du gir tilgang, vil kunne hjelpe deg med evalueringene, sette et forbedringsmåk sammen med deg, og følge opp konkrete tilbakemeldinger.",
      goalEndDate:
        "Denne datoen bestemmer når målet skal være nådd. Det er viktig at du setter en realistisk dato, slik at det er mulig å oppnå endringer, samtidig som at den er knapp nok til å gjøre resultatene sammenlignbare. Vi anbefaler mminst seks måneder.",
      goal: "Beskriv hva du ønsker å forbedre. Dette kan være en spesifikk egenskap, en prosess eller en relasjon. Jo tydeligere målet er, jo bedre!",
      improvementSelector:
        "Her kan du velge hvilke kategorier du ønsker å fokusere på i forbedringsmålet. Velg den eller de som passer best til målet du har satt deg.",
      situation:
        "Hvordan er situasjonen nå? I lys av områdene du ønsker å forbedre, hvordan ligger du an, og hvordan reflekteres dette i resultatene fra evalueringen?",
      plan: "Her kan du legge inn en beskrivelse av din gjennomføringsplan. Hva skal du gjøre for å nå målet? Hvilke aktiviteter skal du gjennomføre, og hva trenger du for å ykkes?",
      goalAccessibleBy:
        "Her kan du velge hvem som skal kunne se målet ditt, men du kan bare velge blant de som kan se evalueringen som målet er startet fra. De som har tilgang til målet, har ikke automatisk tilgang til nye evalueringer, der resultatene sammenlignes.",
      candidate: "Ditt navn. Dette vises i invitasjonene til respondenter, i svarskjemaet og på Jouney-kortene.",
      title: "Din tittel. Dette vises i invitasjonene til respondenter, i svarskjemaet og på Jouney-kortene.",
      groupName: "Gruppens navn. Du kan senere legge til medlemmer i denne gruppen.",
      departmentName: "Avdelingens navn. Du kan senere legge til medlemmer i denne avdelingen.",
      responderMessage:
        "Dersom du har andre tilbakemeldinger enn det som kommer frem i evalueringen, eller om det er noen av svarene du har lyst å utdype, kan du legge det inn her.",
      recommendationName: "For å gi anbefalingen din troverdighet, ber vi om at du legger inn navnet ditt. Dette vil bli vist sammen med anbefalingen.",
      recommendationTitle: "For å gi anbefalingen din troverdighet, ber vi om at du legger inn tittelen din. Dette vil bli vist sammen med anbefalingen.",
      goalIsSuccessHelp:
        "Du må selv avgjøre om målet er nådd eller ikke. Hvis du er i tvil bør du tenke på om du har hatt fremdrift, og om du er nærmere målet enn da du startet. Kanskje det er vellykket selv om resultatene ikke er helt som du hadde håpet? Med kontinuerlig forbedring kommer du snart dit du vil være!",
      goalResult: "Her kan du legge inn din vurdering av resultatet, og begrunne hvorfor målet er nådd eller ikke.",
      departmentForUser:
        "Du kan knytte brukeren til en avdeling, dersom organisasjonen har avdelinger. Disse kan du legge til nedenfor. Under organisasjonsoversikten kan du se resultater for hver avdeling.",
      roleForUser:
        'Rollene bestemmer hvilken tilgang brukeren har til innholdet i organisasjonen. Eier har tilgang til alt, mens støttespillere kan se evalueringer og forbedringsmål. Medlemmer kan kun se egne evalueringer og mål, i tillegg til innhold som er delt med hele organisasjonen. Rollen "Invitert" kan ikke se noe før de har blitt medlemmer.',
      groupsForUser:
        "Hvis ikke rollene gir nok kontroll, kan man opprette egne grupper og melde brukere inn i disse. Det er mulig å gi tilgang til evalueringer og forbedringsmål basert på grupper, for enda bedre kontroll.",
    },
    goalHelp: {
      heading: "Hjelp",
      aboutTo:
        "Du er nå i ferd med å opprette et forbedringsmål. Gå gjennom resultatene fra en av dine fullførte evalueringer og finn ut hva du ønsker å forbedre. Velg kategoriene, lag en plan og start utførelsen!",
      phases: "Forbedringsmålet har tre faser: Oppstartsfasen, utførelsesfasen og avslutningsfasen.",
      initialPhase: "I oppstartsfasen er fokuset å beskrive startssituasjonen og lage en plan for hvordan målet skal nås.",
      executionPhase:
        "I utførelsesfasen kan du følge opp planen, opprette nye evalueringer og måle endringene i resultatene. Du bør også føre en journal i denne fasen, og legge til aktiviteter, refleksjoner og læring underveis.",
      conclusionPhase:
        "Avslutningsfasen blir tilgjengelig en uke etter sluttdatoen for målet. Her skal du evaluere endringene i evalueringresultatene, skrive ned dine refleksjoner og avgjøre om målet var en suksess eller ikke. Hvis du vil, kan du også starte et nytt mål direkte fra den siste evalueringen!",
      acheivement:
        "Vi ber deg ikke om å kvantifisere målene. Fordi det er kontinuerlig forbedring, er det viktigere at du går i riktig retning. Da vil du sikkert nå ditt potensiale innen et par runder.",
      goodLuck: "Lykke til!",
    },
    surveyInfo: {
      heading: "Hjelp",
      aboutTo:
        "Du er nå i ferd med å opprette en evaluering. Den vil bestå av fire spørsmål som vil gi deg et mål på kundetilfredshet innenfor langtidsoppdrag, kurs eller workshops eller tjenesteleveranser.",
      invitations: "Du må legge inn navn og en invitasjonstekst, så får du se en forhåndsvisning av eposten som vil sendes ut til de du inviterer.",
      emailSend:
        "Dersom du velger å invitere noen med en gang, vil eposten sendes ut med en gang du fullfører registreringen. Hvis ikke kan du invitere folk senere.",
      access: "Til slutt blir du bedt om å legge inn noe informasjon om hvem som skal ha tilgang, og hvor lenge undersøkelsen skal vare.",
      slowInvites: "Obs! Dersom du har invitert mange, kan det ta litt tid å opprette evalueringen.",
      goodLuck: "Lykke til!",
      finished1:
        "Denne evalueringen er avsluttet, og respondenter kan ikke lenger svare, selv om de har fått en invitasjon. Det betyr at scoren ikke vil endre seg.",
      finished2:
        "Nå er det tid for å evaluere resultatene og legge inn dine egne refleksjoner. Om det er noe du ønsker å forbedre bør du vurdere å opprette et forbedringsmål!",
      ongoing1: "Denne evalueringen pågår, og du kan invitere nye respondenter. De må svare innen avslutningsdatoen, og deres svar vil dukke opp umiddelbart.",
      ongoing2: "Det kan være lurt å purre på de som ikke svarer. Selv om det går raskt å svare, er det mange som utsetter, og glemmer det.",
    },
    smileyFaceRating: {
      ratingInfo:
        "Vi i Feedback Journey elsker tilbakemeldinger, og vi vil sette stor pris på hva du synes om vår løsning for å samle tilbakemeldinger. Vennligst ranger oss med et smilefjes, og la oss vite hva du synes.",
      receipt: "Tusen takk for din tilbakemelding!",
    },
    misc: {
      serverError: "Det oppsto en feil. Vennligst prøs igjen eller kontakt hei@feedbackjourney.com",
      languageSelectorLabel: "Språk",
      copyToClipboard: "Kopier",
      copiedToClipboard: "Kopiert!",
      moreInfo: "Mer informasjon",
      errorCopying: "Kopiering feilet",
    },
    settings: {
      heading: "Innstillinger",
      profileImageHeading: "Oppdatere profilbilde",
      saveImageBtn: "Lagre",
      imageMissing: "Du må velge et bilde",
      existingImage: "Eksisterende profilbilde",
      updateNameBtn: "Oppdatere navn",
      candidate: "Navn",
      fieldRequired: "Du må fylle ut navn",
      profile: "Profil",
      organization: "Organisasjon",
      members: "Brukere og roller",
      dataPrivacy: "Personvern",
    },
    dataPrivacy: {
      heading: "Data og personvern",
      exportHeading: "Last ned dataene dine",
      exportDescription:
        "Få en kopi av personopplysningene dine — profil, evalueringer, svarene du har mottatt, Journey-kort, forbedringsmål og et faktureringssammendrag — som en JSON-fil.",
      exportButton: "Last ned mine data",
      exporting: "Klargjør dataene dine…",
      exportError: "Vi klarte ikke å klargjøre dataene dine nå. Prøv igjen.",
      deleteHeading: "Slett kontoen din",
      deleteDescription:
        "Dette sletter kontoen din og alle tilbakemeldingsdataene dine permanent: profil, evalueringer, svarene du har mottatt, kommentarer, forbedringsmål og Journey-kort. Dette kan ikke angres.",
      deleteRetentionNote:
        "Fakturerings- og regnskapsdata beholdes der loven krever det. Et eventuelt aktivt abonnement avsluttes, og lagrede betalingsdetaljer fjernes.",
      deleteOrgNote:
        "Hvis du eier en organisasjon som fortsatt har andre medlemmer, overføres eierskapet til et annet medlem slik at de beholder tilgangen sin.",
      confirmLabel: "Skriv e-postadressen din ({1}) for å bekrefte",
      confirmPlaceholder: "din@epost.no",
      deleteButton: "Slett kontoen min",
      deleting: "Sletter kontoen din…",
      deleteError: "Vi klarte ikke å slette kontoen din nå. Prøv igjen eller kontakt support.",
      finalConfirm:
        "Dette sletter kontoen din og alle tilbakemeldingsdataene dine permanent. Dette kan ikke angres. Vil du fortsette?",
      noEmailError:
        "Kontoen din har ingen e-postadresse registrert, så vi kan ikke bekrefte sletting her. Kontakt hey@feedbackjourney.com.",
    },
    menu: {
      settings: "Innstillinger",
      createSurvey: "Ny evaluering",
      contact: "Kontakt og støtte",
      role_owner: "Administrator",
      role_supporter: "Støttespiller",
      role_member: "Medlem",
      role_undefined: " ",
      role_invited: "Invitert",
      role_none: " ",
      card: "Journey-kort",
      surveys: "Evalueringer",
      sharedSurveys: "Delte evalueringer",
      sharedCards: "Delte kort",
      goals: "Forbedringsmål",
      logout: "Logg ut",
      sharedGoals: "Delte forbedringsmål",
      orgDash: "Organisasjonsoversikt",
      myFeedbach: "Min Journey",
      sharedFeedbach: "Delt Journey",
      notifications: "Varsler",
      openMenu: "Åpne meny",
      openNavigation: "Åpne navigasjon",
      unreadNotifications: "Du har {1} uleste varsler",
      dashboard: "Oversikt",
      navigation: "Hovedmeny",
      subscriptionActive: "Abonnement aktivt",
      subscriptionTrial: "Prøveperiode",
      subscriptionInactive: "Ingen aktivt abonnement",
    },
    notifications: {
      heading: "Varsler",
      empty: "Du har ingen varsler.",
      loading: "Laster varsler...",
      markAllRead: "Merk alle som lest",
      type_response: "Et nytt svar er mottatt på din evaluering",
      type_survey_comment: "En ny kommentar ble lagt til på din evaluering",
      type_goal_comment: "En ny kommentar ble lagt til på ditt forbedringsmål",
      type_survey_ended: "Din evaluering er avsluttet",
      type_goal_ended: "Din forbedringsmålperiode er avsluttet",
    },
    frontpage: {
      subTitle: "Kunnskapsbank for kontinuerlig forbedring!",
    },
    dashboard: {
      title: "Oversikt",
      seeMoreRecommendations: "Se flere anbefalinger",
      latestCard: "Siste Journey Card · {1}",
      cardSummary: "Dekker {1} evalueringer fra {2} til {3}, med {4} svar. Siste svar {5}.",
      downloadCard: "Last ned kortet",
      openLiveCard: "Åpne kortet",
      createCard: "Lag et nytt kort",
      noCardEyebrow: "Journey Card",
      noCardTitle: "Lag ditt første Journey Card",
      noCardBody: "Et Journey Card samler scorene fra evalueringene dine i ett kort du kan dele med kunder og på LinkedIn.",
      createFirstCard: "Lag et Journey Card",
      yearTitle: "Reisen din i år",
      yearSurveys: "Evalueringer",
      yearResponses: "Svar",
      yearGoals: "Mål",
      alertStreak: "{1} har vært laveste kategori i {2} evalueringer på rad. Lag et forbedringsmål.",
      alertFollowUp: "{1} er nettopp avsluttet. Et oppfølgingsmøte anbefales.",
      alertRecommendations: "Du har {1} anbefalinger du kan sitere.",
      seeAllSurveys: "Se alle evalueringer",
      phase_planning: "Planlegging",
      phase_execution: "Gjennomføring",
      phase_conclusion: "Konklusjon",
      phase_finished: "Avsluttet",
      goalSuccess: "Lyktes",
      goalFailure: "Lyktes ikke",
      goalFromSurvey: "Fra {1}",
      expiredSubTitle: "Det ser ut som abonnementet er utgått!",
      expiredSubBody:
        "Du kan fortsatt se deg rundt, men ikke opprette nye evalueringer eller brukere. Klikk på knappen under for å aktivere abonnementet igjen.",
      noSubTitle: "Fant ikke et aktivt abonnement!",
      expiredSubBodyNotOwner: `Du kan fortsatt se deg rundt, men ikke opprette nye evalueringer eller brukere. Vennligst kontakt brukeren med eierrolle..`,
      noSubBody: "Du kan fortsatt se deg rundt, men ikke opprette nye evalueringer eller brukere. Klikk på knappen under for å aktivere et abonnement.",
      trialExpiredSubTitle: "Det ser ut som prøveperioden er utgått!",
      trialExpiredSubBody:
        "Du kan fortsatt se deg rundt, men ikke opprette nye evalueringer eller brukere. Klikk på knappen under for å aktivere et abonnement.",
      activeSubscription: "Aktivér abonnement",
      noOrgTitle: "Du er nå i prøveperiode",
      joinOrganization: "Meld deg inn i en organisasjon",
      noOrgDescription: "Da har du litt begrensninger i antall evalueringer og antall inviterte.",
      pendingApprovalTitle: "Venter på godkjenning",
      pendingApprovalBody: "Eieren av {1} må godkjenne forespørselen din før du får tilgang til organisasjonen.",
      noOrgButton: "Registér et organisasjonsabonnement",
      registerSingle: "Oppgradere til enkeltbruker",
      welcomeTitle: "Velkommen til Feedback Journey!",
      welcomeMessage:
        "Profilen din er opprettet. Du er nå klar til å begynne å opprette evalueringer, sette mål og samle verdifull tilbakemelding for å drive kontinuerlig forbedring i organisasjonen din.",
    },
    orgForm: {
      logoLabel: "Last opp firmalogo",
      logoAlt: "Organisasjonslogo",
      uploadLogo: "Last opp firmalogo",
      updateTitle: "Oppdatere organisasjonen",
      title: "Registrér din organisasjon",
      orgName: "Bedriftens navn",
      orgNo: "Organisasjonsnummer",
      country: "Land",
      domain: "Domene - brukere med epost på dette domenet meldes inn i organisasjonen",
      submit: "Registrér",
      fieldRequired: "Dette feltet er påkrevd",
      formErrors: "Oops, det er noen feil her",
      receiptText: "Bedriftsinformasjonen ble oppdatert",
      consentToTerms: "Jeg aksepterer innholdet i databehandleravtalen",
      consentToTermsRequired: "Du må akseptere innholdet i databehandleravtalen",
      termsLink: "Les igjennom databehandleravtalen",
      consentToAgreement: "Jeg aksepterer innholdet i de generelle betingelsene",
      consentToAgreementRequired: "Du må akseptere innholdet i de generelle betingelsene",
      agreementLink: "Les igjennom de generelle betingelsene",
      allowPrivateSurveys: "Skal organisasjonen tillate private evalueringer?",
      allowPrivateSurveysInfo:
        "Ved å tillate private evalueringer, kan brukerne opprette evalueringer og invitere respondenter uten at de blir delt med noen andre i organisasjonen. Dette kan være nyttig dersom brukerne er skeptiske til å gjennomføre evalueringer, og holde dataene for seg selv, i alle fall til svarene er kommet inn. Det gjør også at ansvarlige for kundeoppfølging ikke nødvendigvis får innsikt i de siste evalueringene.",
      orgSettingsHeading: "Organisasjonsinnstillinger",
    },
    surveys: {
      title: "Evalueringer",
      onlyOneSurvey: "Du må registrere- eller melde deg inn i en organisasjon for å opprette flere evalueringer.",
      noSurveys: "Du har ikke opprettet noen evalueringer enda.",
      responderNotesHeading: "Notater",
      submitResponderNotes: "Lagre",
      noResponderNotesText: "Ingen notater er lagt inn",
      noSharedSurveys: "Ingen evalueringer er delt med deg enda.",
      listItemHeading: "Evaluering",
      ends: "avsluttes",
      respondents: "Besvarelser: {1}/{2}",
      start: "Start: {1}",
      end: "Slutt {1}",
      changed: "Endret {1}",
      status_upcoming: "Status: Kommende",
      status_ongoing: "Status: Aktiv",
      status_finished: "Status: Avsluttet",
      surveyHeading: "Evaluering {1}-{2}",
      titleNameOngoing: "{1}, pågår til {2}",
      titleNameFinished: "{1}, avsluttet {2}",
      titleFinished: "Evaluering, avsluttet {1}",
      titleOngoing: "Evaluering, pågår til {1}",
      createSurvey: "Opprett ny evaluering",
      reflectionsHeading: "Refleksjoner",
      noReflectionsText: "Ingen refleksjoner er lagt inn",
      submitReflections: "Lagre refleksjoner",
      editSurvey: "Rediger evaluering",
      serverError: "Lagring av evalueringsdata feilet",
      sharedBy: "Delt av",
      creator_onBehalfOf: "Opprettet av",
      creator_for: "for",
      sharedHeading: "Delte evalueringer",
      followUpMeetingRecommendation:
        "Evalueringen ble nylig avsluttet. Vurder å sette opp et oppfølgingsmøte med din arbeidsgiver, teamleder eller kollegaer for å diskutere resultatene og sette forbedringsmål.",
      backToSurveys: "Tilbake til evalueringer",
      backToShared: "Tilbake til delte evalueringer",
      setImprovementGoal: "Sett et forbedringsmål",
      tabsLabel: "Resultater fra evalueringen",
      tabSummary: "Oppsummering",
      tabResponses: "Svar ({1})",
      tabReflections: "Refleksjoner",
      tabNotes: "Notater",
      totalScore: "Totalscore",
      answersCount: "{1} svar",
      dontKnowsCount: "{1} vet ikke",
      previousSurvey: "Forrige evaluering: {1}",
      previousScore: "Forrige: {1}",
      lowestStreak: "Lavest {1} evalueringer på rad",
      strongScore: "En 8 er en sterk score her. De som svarer, sparer 10 til arbeid i verdensklasse.",
      mayQuote: "Du kan sitere dette",
      accessHeading: "Hvem kan se dette",
      sharedWithGroups: "Delt med: {1}",
      nothingPublished: "Ingenting publiseres før du lager et Journey Card.",
      shareWithGroup: "Del med en gruppe",
      eligibleForCard: "Kan brukes i et Journey Card",
      coachHeading: "AI-coach",
      coachNames: "Rhys og Lisa",
      coachRhys: "Rhys",
      coachLisa: "Lisa",
      askCoach: "Spør coachene",
    },
    questions: {
      knowledge: "Hvordan vil du rangere {1} sine faglige evner?",
      knowledgeInfo: `Hvordan er konsulentens kunnskap innenfor sitt ekspertiseområde sammenlignet med lovnader og forventninger. Hvordan er konsulentens evne til å sette seg inn i deres behov?`,
      knowledgeSharing: "Hvordan vil du rangere {1} sine evner til å dele av sin kunnskap og erfaringer?",
      knowledgeSharingInfo: `Bidrar konsulenten gjennom sine erfaringer og ekspertise på en konstruktiv måte knyttet til deres behov?`,
      influence: "Hvordan vil du rangere {1} sitt bidrag til arbeidsmiljøet?",
      influenceInfo: `På hvilken måte vil du si at konsulenten er deltakende og engasjert i det sosiale miljøet hos dere?`,
      collaboration: "Hvordan vil du rangere {1} sine samarbeidsevner?",
      collaborationInfo: `Hvor enkelt er det å samarbeide med konsulenten, og hvordan er bidraget i og mellom teamene hos dere?`,
      subjectKnowledge: "Hvordan vil du rangere {1} sin faglige kunnskap om emnet som ble presentert?",
      subjectKnowledgeInfo: `Hvordan var kompetansenivået innenfor emnet som ble presentert? Ble innholdet presentert på en måte som var lett å forstå og var det mulig å få svar på spørsmål?`,
      engaging: "Hvordan vil du rangere {1} sin formidlingsevne?",
      engagingInfo: "Ble innholdet presentert på en engasjerende måte, og var det mulig å delta aktivt i kurset/workshopen? Hvordan opplevde du læringen?",
      relevance: "Hvor relevant og nyttig var innholdet i kurset/workshopen for dine behov?",
      relevanceInfo: "Var kurset/workshoppen relevant sammenlignet med det du hadde forventet? Var informasjonen oppdatert og nyttig?",
      satisfaction: "Hvordan vil du rangere din samlede tilfredshet med kurset/workshopen levert av {1}?",
      satisfactionInfo: "Oppfylte kurset/workshopen dine forventninger?",
      expertise: "Hvordan vil du rangere {1} sin faglige kompetanse og ekspertise?",
      expertiseInfo:
        "Hvordan er konsulentens kunnskap innenfor sitt ekspertiseområde sammenlignet med dine forventninger? Hvordan er konsulentens evne til å forstå dine behov?",
      communication: "Hvor fornøyd er du med {1} sin kommunikasjon og tilgjengelighet gjennom oppdraget?",
      communicationInfo: "Opplevde du å få svar på dine spørsmål uten å måtte vente for lenge? Ble konsulentens løfter oppfylt?",
      expectations: "Hvor godt opplevde du at {1} forstod og ivaretok dine behov og forventninger?",
      expectationsInfo: "Ble leveransen som du forventet, og vil du benytte deg av samme tjeneste igjen?",
      quality: "Hvordan vil du rangere den totale kvaliteten på tjenesten levert av {1}?",
      qualityInfo: "Opplevde du at tjenesten var av høy kvalitet og at konsulenten leverte det som var lovet, til den standarden du forventet?",
      summary: "Oppsummering",
      totalScore: "Totalscore",
      invitedHeading: "Inviterte",
      recommendationsHeading: "Anbefalinger",
      messagesHeading: "Tilbakemeldinger",
      resultAnswers: "Antall svar: {1}",
      resultDontKnows: "Vet ikke: {1}",
      responseHeading: "Besvarelse fra {1}",
      anonymousName: "anonym",
      recommendationHeading: "Anbefaling",
      messageHeading: "Tilbakemelding",
      answersHeading: "Svar",
      messageColumn: "Tilbakemelding",
      columnHeading: "Fra",
      dontKnow: "Vet ikke",
      unanswered: "Ikke besvart",
      hasNotResponded: "{1} har ikke svart enda.",
      commentsHeading: "Kommentarer og notater",
      knowledgeLabel: "Kompetanse",
      knowledgeSharingLabel: "Kompetansedeling",
      influenceLabel: "Arbeidsmiljø",
      collaborationLabel: "Samarbeid",
      subjectKnowledgeLabel: "Kunnskap",
      engagingLabel: "Engasjerende",
      relevanceLabel: "Relevans",
      satisfactionLabel: "Tilfredshet",
      qualityLabel: "Kvalitet",
      expectationsLabel: "Forventninger",
      communicationLabel: "Kommunikasjon",
      expertiseLabel: "Ekspertise",
      score10:
        "Score er {1}, noe som betyr at personen er helt i verdenstoppen. Du bør spare 10-eren til en veldig spesiell anledning. Er du sikker på at det ikke er noen forbedringsområder?",
      score9:
        "Score er {1}, noe som betyr at personen er utmerket. Prestasjon på dette nivået er uvanlig. Er du sikker på at det ikke er noen forbedringsområder?",
      score7to8: "Score er {1}, noe som betyr at personen er veldig god. Dette er en god score, og personen gjør en god jobb.",
      score5to6:
        "Score er {1}, noe som betyr at personen er god. Dette er en gjennomsnittlig score og personen klarer seg greit. Samtidig er det noen områder som kan forbedres. Kanskje du skal la personen få vite mer om hva du tenker du i tilbakemeldingsfeltet?",
      score1to4:
        "Score er {1}, noe som betyr at personen ikke er god. Dette er en lav score, og personen møter ikke forventningene. Kanskje du skal la personen få vite mer om hva du tenker du i tilbakemeldingsfeltet?",
      feedbackFromHeading: "Tilbakemelding fra {1}",
    },
    surveyForm: {
      allowAnonymous: "Vil du tillate anonyme respondenter?",
      allowAnonymousInfo:
        "Hvis du tillater anonyme respondenter, vil du få en lenke som du kan dele med hvem som helst. Svarene vil være anonyme, og du vil ikke vite hvem som har svart. Dette kan være spesielt nyttig for kurs og workshops der deltakerne kan svare umiddelbart etter arrangementet.",
      showRecommendation: "Vis anbefalingsdelen i svarskjemaet",
      showRecommendationInfo:
        "Hvis du slår av dette, blir ikke respondentene spurt om anbefalinger. Anbefalinger som allerede er sendt inn vil fortsatt vises i evalueringsdetaljene.",
      surveyTypeLongTerm: "Langtidsoppdrag",
      surveyTypeWorkshop: "Workshop eller kurs",
      surveyTypeDelivery: "Tjenesteleveranse",
      surveyTypeLabel: "Evalueringstype",
      surveyTypeNoChange: "Evalueringstypen kan ikke endres når evalueringen er opprettet",
      selectedSurveyTypeQuestions: "Typen du har valgt vil ha følgende spørsmål:",
      accessHeading: "Tilganger",
      heading: "Ny evaluering",
      surveyAccessStep: "Tilgang og tilgjengelighet",
      invitesHeading: "Invitere mottakere",
      invitesInfo:
        "Ved å legge til epostadressene til dine kollegaer og andre samarbeidspartnere vil de motta en epost med en lenke til svarskjemaet når du er ferdig med denne veiviseren. Du kan spesifisere språket på eposten og svarskjemaet for hver respondent.",
      skipForLater: "Du kan hoppe over dette steget og komme tilbake til det senere, når evalueringen er opprettet.",
      emailPreviewTitle: "Forhåndsvisning av invitasjonsepost",
      emailPreviewInfo:
        "Når du inviterer respondenter vil de få en epost med en lenke til svarskjemaet. Eposten ser slik ut, og inkluderer din egen invitasjonstekst.",
      next: "Neste",
      previous: "Tilbake",
      defaultLang: "Standardspråk",
      editHeading: "Endre evalueringen",
      candidate: "Ditt navn (på invitasjonen)",
      startDate: "Startdao",
      endDate: "Sluttdato",
      invitationText: "Invitasjonstekst",
      submit: "Opprett evaluering",
      submitEdit: "Lagre endringene",
      fieldRequired: "Dette feltet er påkrevd",
      formErrors: "Oops, det er noen feil her",
      dateLogic: "Sluttdato må være etter startdato",
      minimumDuration: "Sluttdato kan ikke være mindre enn en uke frem i tid",
      serverError: "Det oppsto en feil ved lagring av evalueringen din. Vennligst prøv igjen, eller send en epost om problemet til hello@feedbackjourney.com",
      surveyName: "Navn på evalueringen",
      accessibleBy: "Generelt tilgangsnivå",
      accessibleByMe: "Bare meg",
      accessibleBySupporters: "Støttespillere",
      accessibleBySelectedGroups: "Valgte grupper",
      accessibleByOrganization: "Hele organisasjonen",
      onBehalfOf: "Opprett evaluering på vegne av",
    },
    invites: {
      title: "Invitere mottakere",
      emailsLabel: "Legg inn alle epostadressene",
      resendInvite: "Send på nytt",
      showMultiInput: "Legg til flere epostadresser",
      hideMultiInput: "Legg til én og én epostadresse",
      hasBeenResent: "Sendt",
      notSent: "Ikke sendt",
      languageLabel: "Språk",
      anonymousInvites: "Annonyme respondenter",
      anonymousInfo: "Denne evalueringen tillater anonyme respondenter. Du kan dele lenken under med hvem som helst, og svarene vil være anonyme.",
      new: "Invitert",
      serverError: "Det oppsto en feil ved utsending av invitasjonen. Sjekk at epostadressene er korrekte og ikke allerede invitert, og prøv igjen.",
      en: "Engelsk",
      no: "Norsk",
      responded: "Har svart",
      emailed: "Har mottatt epost",
      submit: "Invitér",
      emailLabel: "E-post",
      invitedHeading: "Inviterte",
      invitationTextHeading: "Invitasjonstekst",
      invalidEmail: "Epostadressen er ikke gyldig",
      maxEmailsExceededNoOrg: "Du har nådd maks antall invitasjoner. Vennligst registrer en organisasjon for å invitere flere.",
      maxEmailsExceeded: "You have reached the maximum number of invites.",
      invitesInfo:
        "Vi anbefaler at du diskret følger opp invitasjonene dine. Hvis de ikke svarer etter en stund, bør du spørre om de har mottatt invitasjonen, og be dem sjekke spam-mappen.",
    },
    responderForm: {
      anonymousResponderInfo: "Du svarer anonymt.",
      allQuestionsRequired: "Alle spørsmål må besvares. Velg et tall, eller Vet ikke.",
      questionOf: "Spørsmål {1} av {2}",
      lastStep: "Siste steg",
      lastStepHeading: "Er det noe mer du vil si til {1}?",
      progress: "Framdrift",
      next: "Neste",
      previous: "Tilbake",
      messagePlaceholder: "Hva fungerer bra, og hva kan {1} gjøre enda bedre? Konkrete eksempler hjelper mest.",
      readByRecipient: "{1} leser svarene selv.",
      poweredBy: "Levert av",
      responsesNotAnonymous: "Dine svar er ikke anonyme. {1} kan identifisere deg basert på lenken du har brukt.",
      title: "Evalueringsskjema for",
      invitationHeading: "Invitasjon",
      messageLabel: "Øvrig tilbakemelding (valgfritt)",
      recommendationLabel: "Anbefalingstekst",
      recommendationInfo: "Hvis du vil, kan du gi en anbefaling med navn og tittel. {1} kan da bruke den i markedsføring, som i CVen, på nettsider og i tilbud.",
      submit: "Send",
      allQuesstionsRequired: "Dette spørsmålet må besvares",
      formErrors: "Oops, det mangler noen svar",
      serverError: "Det oppsto en feil ved lagring av svaret ditt. Vennligst prøv igjen, eller send en epost om problemet til hello@feedbackjourney.com",
      thankYouHeading: "Tusen takk!",
      receiptText: "Dine svar blir satt pris på, og er verdifulle! Hvis du har mer informasjon, vennligst ta kontakt med {1} og fortell om det.",
      giveRecommendation: "Vil du gi en anbefaling av {1}?",
      recommendationName: "Hva er ditt navn?",
      recommendationNameInfo: "Vi ber om navn og tittel for å øke troverdigheten når anbefalingen er presentert i CVer, etc.",
      recommendationTitle: "Hva er din tittel?",
    },
    cardForm: {
      heading: "Opprett Journey-kort",
      firstSurvey: "Første evaluering",
      lastSurvey: "Siste evaluering",
      chooseSurvey: "Velg en evaluering",
      rangeLabel: "Evalueringer på kortet",
      rangeSummary: "{1} evalueringer, {2} svar",
      rangeAllIncluded: "Alle evalueringer mellom den første og den siste er med. Ingen kan velges bort.",
      surveyTypeFilterLabel: "Evalueringstype",
      cardTitle: "Tekst på kortet",
      noCards: "Du har ikke opprettet noen Journey-kort enda",
      noSharedCards: "Det er ikke opprettet noen delte Journey-kort enda",
      loadCardsError: "Vi fikk ikke hentet Journey-kortene. Last siden på nytt, eller prøv igjen senere.",
      survey: "Evaluering",
      startingSurvey: "Fra og med",
      endingSurvey: "Til og med",
      selectSurveyInfo: "Velg intervallet av evalueringer som skal inkluderes i kortet.",
      surveys: "Evalueringer",
      selectedHeading: "Evalueringsintervall",
      preview: "Forhåndsvisning",
      submit: "Opprett",
      invervalError: "Du må velge fra- og til-evaluering. Det kan være den samme.",
      createCard: "Opprett nytt Journey-kort",
      onlyOneCard: "Du må registrere- eller melde deg inn i en organisasjon for å opprette flere Journey-kort.",
      serverError: "Det oppsto en feil ved lagring av kortet. Vennligst prøv igjen senere eller kontakt support.",
      imageNotReady: "Forhåndsvisningen er ikke klar ennå. Vent litt og prøv igjen.",
      noSurveys: "Du har ikke hatt noen evalueringer enda. Du må ha minst en evaluering for å opprette et Journey-kort.",
      exposeDomains: "Vis svargivernes domener på det offentlige kortet",
      "help.exposeDomains": "Hvis dette er av, vil ikke den offentlige visningen av Journey-kortet vise svargivernes e-postdomener.",
      groupsHeading: "Hvem i organisasjonen ser kortet",
      groupsHelp: "Velger du ingen grupper, ser hele organisasjonen kortet under delte kort. Den offentlige lenken til kortet virker som før.",
      recommendationsHeading: "Anbefalinger på kortet",
      recommendationsInfo:
        "Du kan velge inntil {1} av anbefalingene som er gitt i evalueringene over. De vises under kortet — med navn og tittel på den som ga anbefalingen, aldri e-postadressen.",
      noRecommendations: "Det ble ikke gitt noen anbefalinger i evalueringene du valgte.",
      recommendationsSelected: "{1} av {2} valgt",
      recommendationsLimitReached: "{1} av {1} valgt. Fjern en for å velge en annen.",
    },
    card: {
      registered: "Opprettet {1} - ",
      visits: "Åpnet {1} ganger, {2} fra QR-kode",
      visitsHelp:
        "Tallet gjelder all trafikk til kortet: mennesker, men også søkemotorer, bots og forhåndsvisninger i for eksempel LinkedIn og Slack. QR-tallet teller besøk fra en skannet QR-kode.",
      verifiedHeading: "Verifisert av Feedback Journey",
      verifiedSeries: "Kortet dekker alle evalueringer fra den første til den siste. Ingen kan plukkes ut, så et sterkt kort betyr sterke resultater gjennom hele perioden.",
      verifiedEyebrow: "Verifisert av Feedback Journey",
      verifiedBuiltOn: "Dette bygger kortet på",
      surveyAnswers: "· {1} svar",
      surveyPeriod: "{1} til {2}",
      publicChip: "Verifisert Journey Card",
      publicHeading: "Tilbakemeldinger fra kunder til {1}, kontrollert mot de opprinnelige svarene.",
      publicSummary: "{1} svar fra {2} evalueringer, {3} til {4}. Feedback Journey tar vare på svarene, så tallene på denne siden kan ikke endres eller plukkes ut.",
      howVerificationWorks: "Slik virker verifiseringen",
      createOwnCard: "Lag ditt eget Journey Card",
      copyCardLink: "Kopier lenken til kortet",
      cardLinkCopied: "Lenken er kopiert",
      publicRecommendationsEyebrow: "Anbefalinger",
      publicRecommendationsHeading: "Med kundenes egne ord",
      publicRecommendationsLead: "Skrevet av svargivere i evalueringene over, publisert med deres samtykke.",
      ctaHeading: "Et Journey Card er et bevis du kan legge ved en CV eller et tilbud.",
      ctaBody: "Send korte evalueringer til kundene underveis. Feedback Journey samler svarene og gjør hele serien om til et kort ingen kan endre.",
      ctaButton: "Lag din første evaluering gratis",
      ctaLink: "Slik virker verifiseringen",
      footerCompany: "Feedback Journey, Aiga AS",
      footerOwner: "Eieren av kortet bestemmer hva som deles, og kan avpublisere det når som helst.",
      footerPrivacy: "Personvern",
      footerReport: "Rapporter et kort",
      verifiedSurveys: "Evalueringer som inngår",
      verifiedDomains: "Svar fra",
      anonymousResponders: "Anonyme",
      anonymousDomain: "Anonyme",
      noOfResponders: "Antall svar",
      latestResponse: "Siste besvarelse",
      scanToVerify: "Skann for å verifisere",
      verifiedCard: "Verifisert kort",
      answersPill: "{1} svar",
      latestPill: "Siste {1}",
      surveysPill: "{1} evalueringer",
      totalScoreLabel: "Total",
      knowledgeLabel: `Kompetanse
 `,
      knowledgeSharingLabel: `Kompetanse-
deling`,
      influenceLabel: `Arbeidsmiljø
 `,
      collaborationLabel: `Samarbeid
 `,
      subjectKnowledgeLabel: `Emne-
kunnskap`,
      engagingLabel: `Engasjerende
  `,
      relevanceLabel: `Relevans
  `,
      satisfactionLabel: `Tilfredshet
  `,
      qualityLabel: ` 
Kvalitet`,
      expectationsLabel: `Forventninger
  `,
      communicationLabel: ` 
Kommunikasjon`,
      expertiseLabel: `Ekspertise
  `,
      cardStatsHeading: "Journeykort: Mer info",
      responderDomains: "Svardomener",
      uniqueResponders: "Unike svarere",
      earliestResponse: "Tidligste svar",
      statsLatestResponse: "Siste svar",
      moreInfo: "Mer info",
      noOfSurveys: "Antall evalueringer",
      recommendationsHeading: "Anbefalinger",
    },
    createProfile: {
      emailMissing: "Brukeren du logget på med mangler epost. Kontakt support.",
      serverError: "Det oppsto en feil ved lagring av profilen din. Vennligst prøv igjen.",
      nameMissing: "Fullt navn er påkrevd.",
      candidate: "Fullt navn",
      heading: "La oss bli litt bedre kjent",
      title: "Stillingstittel",
      saveBtn: "Opprett profil",
      profileImageLabel: "Profilbilde",
      profileImageAlt: "Profilbilde",
      editHeading: "Oppdatere profil",
      termsLink: "Les personvernerklæringen",
      consentToTerms: "Jeg samtykker til innholdet i avtalen",
      consentToTermsRequired: "Du må akseptere innholdet i avtalen",
      uploadImage: "Last opp profilbilde",
    },
    imageUploader: {
      chooseFile: "Slipp bildet her, eller trykk og velg fra datamaskinen",
      zoomLabel: "Zoom",
      cancel: "Avbryt",
      submitImage: "Lagre bilde",
    },
    userManagementForm: {
      name: "Navn",
      department: "Avdeling",
      role: "Rolle",
      departmentDeleted: "{1} er slettet",
      title: "Brukere",
      roleOwner: "Administrator",
      roleMember: "Medlem",
      roleInvited: "Invitert",
      roleSupporter: "Støttespiller",
      departmentsTitle: "Avdelinger",
      noDepartments: "Det er ikke lagt til noen avdelinger.",
      editDepartment: "Endre avdelinger",
      addDepartment: "Legg til avdeling",
      departmentNameLabel: "Legg til avdeling",
      submit: "Lagre",
      noDepartment: "Ingen",
      goBack: "Tilbake",
      invalidDepartment: "Du må oppgi navn på avdelingen",
      inviteUsersTitle: "Invitere brukere",
      inviteUsersDescription:
        "Du kan invitere brukere fra organisasjonen din ved å dele lenken nedenfor med dem. Når de har registrert seg og logget inn, vil de kunne melde seg inn i organisasjonen.",
      groupsHeading: "Grupper",
      editGroups: "Legg til- eller fjerne grupper",
      addGroup: "Legg til grupper",
      editGroup: "Endre grupper",
      groupNameLabel: "Gruppenavn",
      invalidGroup: "Du må oppgi et navn på gruppen",
      memberOf: "Medlem av",
      availableGroups: "Andre grupper",
      save: "Lagre",
      accessFor: "Tilgjengelig for",
      noGroups: "Organisasjonen har ingen grupper enda.",
      inviteUsersInfo:
        'Alle som har lenken kan melde seg inn i organisasjonen. De får rollen "Invitert" når de logger inn, og har ikke tilgang til noe innenfor organisasjonen med denne rollen. Når de har meldt seg inn i organisasjonen må du gi dem rollen "Medlem" eller "Støttespiller" for å gi dem tilgang til innhold.',
      groupsInfo:
        "Grupper er en måte å organisere brukere i organisasjonen på. Du kan gi tilgang til innhold basert på grupper, for eksempel evalueringer og mål. Her kan du legge til eller fjerne grupper, som du senere kan melde brukere inn i fra brukerlisten ovenfor.",
      departmentsInfo:
        "Avdelinger er en måte å organisere brukere i organisasjonen på. Du kan se statistikk for hver avdeling under organisasjonsoversikten. Her kan du legge til eller fjerne avdelinger, som du senere kan knytte brukere til fra brukerlisten ovenfor. En bruker kan bare høre til én avdeling.",
    },
    systemMessages: {
      contactFormError: "Det oppsto en feil ved innsending av skjemaet. Vennligst prøv igjen.",
      joinFailed: "Det oppsto en feil under innmelding i organisasjonen. Vennligst prøv igjen, eller kontakt support.",
      orgFetchError: "URLen du la inn er ikke gyldig. Vær vennlig å legge inn riktig URL og prøv igjen.",
      loading: "Henter data...",
      notFound: "Kan ikke finne innholdet du prøver å hente",
      surveyEnded: "Denne evalueringen er dessverre avsluttet",
      alreadyResponded: "Du har allerede svart på denne evalueringen",
      login: "Logger inn...",
      errorLogin: "Pålogging feilet",
      verifyEmail: "Du må verifisere epostadressen. Sjekk inboksen, og logg inn på nytt.",
      invalidDomain:
        "Feedback Journey er beregnet for organisasjoner, og brukerne kobles til organisasjonen ved hjelp av epostdomenet. Domenet du har logget på med deles av andre, og kan dessverre ikke benyttes.",
    },
    improvementGoals: {
      noSelectedCategories: "Ingen valgte kategorier",
      noSharedGoals: "Det er ingen mål som er delt med deg",
      noGoals: "Du har ikke satt noen forbedringsmål enda. Start med en evaluering og sett et forbedringsmål ut fra resultatene fra den.",
      editOrgHeading: "Endre organisasjonsmål",
      orgHeadingCreate: "Opprett et organisasjonsmål",
      create: "Opprett et forbedringsmål",
      missingOriginalSurvey: "Forbedringsmålet må opprettes fra en evaluering. Start fra en fullført evaluering og prøv igjen.",
      fieldRequired: "Feltet er påkrevd",
      heading: "Opprett et forbedringsmål",
      goalHeading: "Forbedringsmål",
      editHeading: "Endre forbedringsmål",
      knowledgeLabel: "Kompetanse",
      knowledgeSharingLabelLong: "Kompetansedeling",
      knowledgeSharingLabel: "Deling",
      influenceLabel: "Arbeidsmiljø",
      collaborationLabel: "Samarbeid",
      subjectKnowledgeLabel: "Kunnskap",
      expectationsLabel: "Forventninger",
      qualityLabel: "Kvalitet",
      communicationLabel: "Kommunikasjon",
      expertiseLabel: "Ekspertise",

      engagingLabel: "Engasjerende",
      relevanceLabel: "Relevans",
      satisfactionLabel: "Tilfredshet",
      categoriesLabel: "Velg forbedringskategorier",
      name: "Gi målet ditt et navn",
      endDate: "Når vil du at målet skal være oppnådd? (anbefalt 6 måneder)",
      goal: "Beskriv målet",
      situation: "Beskriv start-situasjonen",
      plan: "Beskriv gjennomføringsplanen for å oppnå målet",
      result: "Beskriv resultatet av arbeidet med målet i perioden",
      submit: "Opprett mål",
      submitEdit: "Oppdater målet",
      serverError: "Vi klarte ikke å lagre målet. Vennligst prøv igjen eller kontakt support.",
      accessibleBy: "Tilgjengelig for",
      accessibleByMe: "Bare meg",
      accessibleBySupporters: "Støttespillere",
      accessibleByOrganization: "Hele organisasjonen",
      goalDescriptionHeading: "Målbeskrivelse",
      improvementCategories: "Forbedringskategorier",
      initialSituationHeading: "Start-situasjonen",
      planHeading: "Plan for utførelse",
      registeredLabel: "Startet: {1}",
      endDateLabel: "Avslutning: {1}",
      sharedGoalsTitle: "Delte forbedringsmål",
      goalsTitle: "Forbedringsmål",
      originalSurvey: "Opprinnelig evaluering",
      latestSurvey: "Siste evaluering",
      phasesInitial: "1. Planlegging",
      phasesExec: "2. Utførelse",
      phasesConclusion: "3. Konklusjon",
      latestSurveys: "Siste evalueringer",
      createSurvey: "Start en ny evaluering",
      comments: "Kommentarer",
      conclusionHeading: "Konklusjon",
      statusongoing: "Pågående",
      statusfinished: "Avsluttet",
      noRecentSuveys: "Det er ikke opprettet noen evalueringer siden målet ble satt.",
      conclusionEditHeading: "Hvordan gikk det?",
      submitConclusion: "Lagre endringer",
      isSuccessLabel: "Vil du vurdere at målet ble oppnådd?",
      isSuccessYes: "Ja",
      isSuccessNo: "Nei",
      success: "Oppnådd",
      fail: "Ikke oppnådd",
      journalHeading: "Journal",
      patienceConclusion: "Konklusjonen blir tilgjengelig mot slutten av forbedringsperioden.",
      emptyConclusion: "Endre målet for å legge til konklusjon",
      status_finished: "Status: Avsluttet",
      status_planning: "Status: Planlegging",
      status_conclusion: "Status: Konklusjon",
      status_execution: "Status: Utførelse",
      createNewGoal: "Opprett et nytt mål",
      sharedBy: "Delt av {1}",
      orgRecentSurveyResults: "Nylige evalueringsresultater",
      orgResultsFromTo: "Resultater fra {1} til {2}",
      orgOriginalResultsFromTo: "Opprinnelige resultater fra {1} til {2}",
      totalSurveys: "Antall evalueringer",
      totalAnsvars: "Antall svar",
      orgGoalCategoriesPeriod: "Resultat fra siste seks måneder",
      backToGoals: "Tilbake til forbedringsmål",
      backToOrganization: "Tilbake til organisasjonen",
      categoryBadge: "Kategori: {1}",
      editGoal: "Endre mål",
      startLabel: "Start {1}",
      endLabel: "Slutt {1}",
      phasesHeading: "Faser",
      phasePlanningText: "Beskriv målet, situasjonen og planen.",
      phaseExecutionText: "Følg planen, skriv i journalen og be om tilbakemelding.",
      phaseConclusionText: "Se tilbake og vurder om målet ble nådd.",
      goalCardHeading: "Mål",
      situationCardHeading: "Situasjon",
      planCardHeading: "Plan",
      colSurvey: "Evaluering",
      colLastResponse: "Siste svar",
      colRespondents: "Svar",
      baseline: "Utgangspunkt",
      open: "Åpen",
      movementUp: "Opp siden utgangspunktet: {1}.",
      movementDown: "Ned siden utgangspunktet: {1}.",
      movementSame: "Uendret: {1}.",
      movementOpen: "{1} evalueringer er fortsatt åpne, så tallene kan endre seg.",
      nextSurveyHeading: "Neste evaluering",
      nextSurveyText: "En ny evaluering viser om planen virker.",
      successHeading: "Hva som teller som suksess",
      successText1: "Vurderingen er kvalitativ, og den er din.",
      successText2: "Små forbedringer teller.",
      successText3: "Neste mål starter fra siste evaluering.",
      sharedWithHeading: "Delt med",
      coachHeading: "Din coach",
      coachName: "Lisa Hauge",
      coachText: "Lisa leser målet, planen og journalen, og svarer i journalen.",
      askCoach: "Spør Lisa",
    },
    comments: {
      addCommentHeading: "Legg til kommentar",
      fieldRequired: "Kommentarteksten kan ikke være tom",
      serverError: "Vi kunne ikke lagre din kommentar. Vennligst prøv igjen eller kontakt support",
      submit: "Lagre kommentar",
      formErrors: "Manglende kommentar",
    },
    aiCoach: {
      buttonLabel: "AI-coach",
      heading: "Generer AI-kommentar",
      info: "Du kan få en AI-generert kommentar som kan hjelpe deg å oppdage mønstre i svarene, og gi deg forslag til hva du kan fokusere på for å forbedre deg.",
      dataNotice: "Du bør oppdatere dine refleksjoner og notater før du genererer en AI-kommentar, for å få best mulig resultat.",
      dataSources: "AI-coachen kan gi en kommentar basert på dine resultater, kommentarrer, meldinger og anbefalinger i denne evalueringen.",
      aiDisclosure: "For å lage forslaget sendes dette innholdet til vår AI-leverandør, Google Gemini. Se personvernerklæringen vår for detaljer.",
      confirm: "Generer",
      cancel: "Avbryt",
      loading: "Genererer... Du kan forlate siden i mellomtiden.",
      writingBoth: "Rhys og Lisa skriver",
      writingLisa: "Lisa skriver",
      error: "Kunne ikke generere AI-kommentar. Vennligst prøv igjen.",
    },
    orgDash: {
      scoreHeading: "Organisasjonsscore",
      surveyTypeHeading_delivery: "Evalueringstype - Tjenesteleveranse",
      "surveyTypeHeading_long-term": "Evalueringstype - Langtidsoppdrag",
      surveyTypeHeading_workshop: "Evalueringstype - Workshop eller kurs",
      orgScoreInfo: "Disse verdiene viser score på tvers av alle evalueringer i organisasjonen. Private evalueringer er ikke inkludert.",
      periodForever: "Siden starten",
      periodYear: "Siste 12 måneder",
      period6m: "Siste 6 måneder",
      period3m: "Siste 3 måneder",
      periodLabel: "Velg periode",
      periodInterval: "Velg fra- og til",
      answersLabel: "Antall svar",
      surveyLabel: "Evalueringer",
      updateBtn: "Oppdatér",
      toDate: "Til",
      fromDate: "Fra",
      candidatePlaceholder: "[konsulentens navn]",
      departmentLabel: "Avdeling",
    },
    subscription: {
      activateSub: "Aktivere abonnement",
      stripeInfo:
        "Feedback Journey benytter Stripe til betalinger. Når du klikker på knappen under vil du bli sendt til Stripe, der du vil kunne administrere abonnementet, betalinger og hente fakturaer.",
      subscriptionOrderText: "Start en ny 12-måneders periode med evalueringer og kontinuerlig forbedring",
      subscriptionOrderInfo: "Du blir sendt til Stripe for å fullføre betalingen.",
      goToCheckout: "Gå til betaling",
      subscriptionActivatedHeading: "Abonnement aktivert",
      settingsHeading: "Abonnement",
      detailsHeading: "Abonnementsdetaljer",
      startDateLabel: "Startdato",
      endDateLabel: "Sluttdato",
      renewalDateLabel: "Fornyelsdato",
      cancelSubscription: "Kanseller abonnement",
      cancelConfirm: "Er du sikker på at du vil kansellere? Abonnementet ditt forblir aktivt til slutten av gjeldende periode.",
      cancelSuccess: "Abonnementet ditt er kansellert og vil ikke fornyes.",
      subscriptionStatus: "Status",
      status_active: "Aktivt",
      status_undefined: "Ingen aktivt abonnement",
      status_none: "Ingen aktivt abonnement",
      status_ended: "Utgått",
      status_created: "Opprettet",
      subscriptionType: "Type",
      type_trial: "Individuell (prøveperiode)",
      type_recurring: "Individuell",
      type_org: "Organisasjon",
      type_none: "Ingen",
      openPortal: "Administrere abonnement",
      subscriptionActivatedSuccess: "Abonnementet er nå aktivert",
      subscriptionActivationError: "Det oppsto en feil ved forsøk på å aktivere abonnementet. Vennligst prøv igjen, eller kontakt support.",
      checkoutCancelled: "Betalingen ble avbrutt. Vennligst aktiver et abonnement for å fortsette å bruke Feedback Journey.",
    },
    join: {
      aboutTo: "Du er i ferd med å melde deg inn i organisasjonen {1}",
      join: "Meld deg inn i {1}",
      joinFailed: "Det oppsto en feil under innmelding i organisasjonen. Vennligst prøv igjen, eller kontakt support.",
      orgFetchError: "Det oppsto en feil ved henting av organisasjonsinformasjon. Vennligst prøv igjen, eller kontakt support.",
      joinByLinkHeading: "Meld deg inn i en organisasjon",
      pasteLink: "Har du en invitasjonslenke? Lim den inn her:",
      okButton: "OK",
      joining: "Melder deg inn...",
    },
    pricing: {
      heading: "Velg en plan",
      subheading: "Få mest mulig ut av Feedback Journey. Oppgrader eller meld deg inn i en organisasjon når som helst.",
      trialTitle: "Gratis prøveperiode",
      trialPrice: "Gratis",
      trialPriceNote: "Ingen betalingskort nødvendig",
      trialFeature1: "Opptil 3 evalueringer",
      trialFeature2: "Opptil 5 inviterte respondenter",
      trialFeature3: "Tilgang til alle evalueringstyper",
      trialCta: "Fortsett med prøveperioden",
      singleTitle: "Enkeltbruker",
      singlePriceYearly: "€67",
      singlePriceNoteYearly: "per år",
      singlePriceQuarterly: "€24",
      singlePriceNoteQuarterly: "per 3 måneder",
      singleBillingYearly: "Årlig",
      singleBillingQuarterly: "Kvartalvis",
      singleBadgeYearly: "Beste verdi",
      singleFeature1: "Ubegrensede evalueringer",
      singleFeature2: "Ubegrensede respondenter",
      singleFeature3: "Forbedrinsmål og Journey-kort",
      singleCta: "Kom i gang",
      orgTitle: "Organisasjon",
      orgPrice: "€1 500",
      orgPriceNote: "per år",
      orgFeature1: "Alt i Enkeltbruker",
      orgFeature2: "Organisasjonsoversikt",
      orgFeature3: "Avdelingsadministrasjon",
      orgFeature4: "Rollebasert tilgangsstyring",
      orgCta: "Registrér organisasjon",
      orgOwnerOnly: "Bare eieren av organisasjonen kan kjøpe denne planen.",
      joinOrganization: "Har du en invitasjon? Meld deg inn i en organisasjon",
      vatNote: "Alle priser eks. mva. Abonnement faktureres via Stripe.",
      viewPlans: "Se prisplaner",
    },
    announcements: {
      heading: "Kunngjøringer",
      empty: "Det er ingen kunngjøringer for øyeblikket.",
    },
  },
};
